import { useMemo } from 'react';

import type { Receiver } from '../../../generated-types';
import { useFormContext } from '../../../hooks/useForm';
import { ReceiverDetailsAction, ReceiverDetailsActionType } from './actions';
import { ReceiverDetailsState } from './state';
import { ReceiverDetailsError } from './validate';

export default (receiver: Receiver, santizedAccountNumber: string) => {
    const {
        state: { accountNumber, accountName },
    } = useFormContext<ReceiverDetailsState, ReceiverDetailsAction, ReceiverDetailsError, ReceiverDetailsActionType>();
    return useMemo(
        () =>
            accountName !== receiver.name ||
            accountNumber !== receiver.accountNumber.value ||
            receiver.accountNumber.value !== santizedAccountNumber,
        [receiver, accountNumber, accountName, santizedAccountNumber],
    );
};
